import React from 'react';
import { getAllProviderSMS, smsRates } from '../../api-services';
import moment from 'moment';
import Country from '../../components/Country';
import TableManager from '../../components/TableManager';
import { createTable } from '@tanstack/react-table';
import SMSRateUpload from './Modals/SMSRateUpload';
import { useQuery } from 'react-query';
import { useState } from 'react';
import SMSUpdateMargin from './Modals/CallUpdateMargin';
import { Country as GlobalCountries } from 'country-state-city';

const table = createTable();

const DateFilterTypes = [
  { label: 'Today', value: 'Today' },
  { label: 'Yesterday', value: 'Yesterday' },
  { label: 'Last 7 Days', value: 'Last 7 Days' },
  { label: 'Last 30 Days', value: 'Last 30 Days' },
  { label: 'This Month', value: 'This Month' },
  { label: 'Last Month', value: 'Last Month' },
  { label: 'Custom', value: 'Custom' },
];

const currencyOptions = [
  { label: 'EURO', value: 'EURO' },
  { label: 'XOF', value: 'XOF' },
  { label: 'USD', value: 'USD' },
  { label: 'GBP', value: 'GBP' },
  { label: 'NGN', value: 'NGN' },
];

const initialValues = {
  filter: [
    {
      currency: '',
      a_filter_type: '',
      placeholder: 'Select Currency...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: currencyOptions,
      label: 'Currency',
    },
    {
      country: '',
      a_filter_type: '',
      placeholder: 'Select Country...',
      type: 'select',
      shouldFilterOptionDisabled: true,
      selectOptions: GlobalCountries?.getAllCountries(),
      label: 'Country',
    },

    {
      date: {
        from: '',
        to: '',
      },
      a_filter_type: '',
      placeholder: 'Custom Date Range...',
      type: 'date',
      shouldFilterOptionDisabled: false,
      filterOptions: DateFilterTypes,
      selectOptions: [],
      label: 'Date',
    },
  ],
};
const Sms = () => {
  const [isUpload, setUploadRate] = useState(false);
  const [isUpdate, setUpdateMargin] = useState(false);
  const [filters, setFilters] = useState([]);
  const [openFilter, setOpenFilter] = useState(false);
  const { data: AllProvidersSMS } = useQuery(
    'getAllProviderSMS',
    getAllProviderSMS,
    {
      select: (data) => data?.data?.data,
    },
  );

  const columns = [
    table.createDataColumn('created_at', {
      id: 'created_at',
      header: 'Date',
      cell: (props) => moment(props.getValue()).format('YYYY-MM-DD: HH:mm:ss'),
      isSortable: true,
    }),
    table.createDataColumn('alpha2code', {
      id: 'alpha2code',
      header: 'Country',
      cell: (props) => <Country isoCode={props.getValue()} />,
      textAlign: 'left',
    }),
    table.createDataColumn('destination', {
      id: 'destination',
      header: 'Destination',
      textAlign: 'left',
    }),
    table.createDataColumn('rate', {
      id: 'rate',
      header: 'Buy rate',
      isSortable: true,
    }),
    table.createDataColumn('sale_rate', {
      id: 'sale_rate',
      header: 'Sell rate',
      isSortable: true,
    }),
    table.createDataColumn('currency', {
      id: 'currency',
      header: 'Currency',
    }),
    table.createDataColumn('status', {
      id: 'status',
      header: 'Status',
      cell: (props) =>
        props.getValue() ? (
          <a className="text-success" href="#">
            Activated
          </a>
        ) : (
          <a className="text-danger" href="#">
            Deactivated
          </a>
        ),
    }),
  ];

  const handleUploadRates = () => {
    setUploadRate(true);
  };

  const handleUpdateMargin = () => {
    setUpdateMargin(true);
  };

  return (
    <>
      <TableManager
        table={table}
        columns={columns}
        filter={filters}
        fetcherKey="smsRates"
        fetcherFn={smsRates}
        title="SMS Rates"
        shouldUpload={true}
        uploadCtaFunction={handleUploadRates}
        uploadCtaLabel="Upload Rates"
        updateMargin={true}
        updateMarginCtaFunction={handleUpdateMargin}
        updateMarginCtaLabel="Update Margins"
        shouldFilter={true}
        openFilter={openFilter}
        setOpenFilter={setOpenFilter}
        initialValues={initialValues}
        setFilters={setFilters}
        filters={filters}
      />

      {isUpload && (
        <SMSRateUpload
          setOpenModal={setUploadRate}
          openModal={isUpload}
          AllProvidersSMS={AllProvidersSMS}
        />
      )}

      {isUpdate && (
        <SMSUpdateMargin
          setOpenModal={setUpdateMargin}
          openModal={isUpdate}
          AllProvidersCall={AllProvidersSMS}
        />
      )}
    </>
  );
};

export default Sms;
